export default {
    '$route.name': function() {
        if (this.$route.name === 'Criar agência') {
            this.resetAgency()
        }
    },
}
